import { ACCESS_TOKEN } from "./keys";

export const getAccessToken = () => localStorage.getItem(ACCESS_TOKEN) || "";
